import { jsx } from "react/jsx-runtime";
import { gradientText } from "./Highlight.css.mjs";
const Highlight = ({ children }) => /* @__PURE__ */ jsx("span", { className: gradientText, children });
export {
  Highlight
};
